import {IGamePartsViewModel} from "../game-parts/game-parts-view-model.interface";
import {GameInfo} from "../../../games/game-info";
import {IGameSize} from "../open-game-api-callers/open-game-api-response.interface";
import {Nullable, NullableUndefinedString, UndefinedNumber} from "../../../../../common/types/nullable-types";
import {IRunningGameControllerViewModel} from "../game-controller/running-game-controller.interface";
import {IOpenHistoryGameParams} from "../../game-runner.service.interface";
import {IFreePlayVoucherViewModel} from "../../../free-play/vouchers/free-play-voucher-view-model.interface";

export enum GameModeEnum {
    Demo = 0,
    Real = 1,
    History = 2
}

export interface IGameSessionDataViewModel {
    readonly totalBets: number;
    readonly totalWins: number;
    readonly vendorGameSessionId: NullableUndefinedString;
    readonly regulationGameSessionId: NullableUndefinedString;
    readonly regulationParticipationTicketId: NullableUndefinedString;
}

export interface IGameFreePlayContextViewModel {
    readonly isFreePlay: boolean;
    readonly currentFreePlayVoucher: IFreePlayVoucherViewModel | null;
    readonly otherAvailableVouchersForCurrentGame: IFreePlayVoucherViewModel[];
}

export interface IGameContextViewModel {
    readonly gameMode: GameModeEnum;
    readonly gameInfo: GameInfo;
    readonly controller: IRunningGameControllerViewModel;
    readonly gameParts: IGamePartsViewModel;
    readonly launchGameUrl: string | null;
    readonly gameSize: Nullable<IGameSize>;
    readonly isGameResizable: boolean;
    readonly freePlayContext: IGameFreePlayContextViewModel;
    readonly historyGameParams: IOpenHistoryGameParams | undefined;
    readonly gameSessionData: IGameSessionDataViewModel;
    readonly referrerId: UndefinedNumber;
    readonly allowSwitchBetweenDemoAndReal: boolean;
}